import { render } from "./examinationAnalysis.vue?vue&type=template&id=1a9bf974&scoped=true"
import script from "./examinationAnalysis.vue?vue&type=script&lang=js"
export * from "./examinationAnalysis.vue?vue&type=script&lang=js"

import "./examinationAnalysis.vue?vue&type=style&index=0&id=1a9bf974&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9bf974"]])

export default __exports__